
import bcrypt from 'bcryptjs';
import CryptoJS from 'crypto-js';

const { VUE_APP_FLA_SECRET_KEY } = process.env

// these need to align with the backend values stored in the .env file
// ---------------------------
const TOKEN_VAR = "FLA_token"       // local storage key that holds the token value
const U_ID = "FLA_u_id"             // local storage key that holds the userId value
// ---------------------------


// used for passwords
function Encrypt( string ) {
  const salt = bcrypt.genSaltSync(10);
  return bcrypt.hashSync(string, salt);
};

// used for encrypting API Keys
function AesEncrypt( string ) {
  try {
    const val = CryptoJS.AES.encrypt( string, VUE_APP_FLA_SECRET_KEY );
    return [ null, val.toString() ];
  } 
  catch (error) {
    return [ error ];
  }
}

function AesDecrypt( string ) {
  try {
    if ( !string ) return [null, undefined];
    const bytes = CryptoJS.AES.decrypt( string, VUE_APP_FLA_SECRET_KEY );
    const bytesString = bytes.toString( CryptoJS.enc.Utf8 );
    return [ null, bytesString ];
  } 
  catch (error) {
    console.log(error)
    return [ error ];
  }
}


function ValidateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

/**
 * Used mainly for labOptions keys
 * @param {String} str camel case string to separate
 * @returns separated string
 */
function SeparateWords( str ) {
  const _str = str
    .replace('address', '')
    .replace(/(?!^)([A-Z])/g, ' $1');
  return _str.charAt(0).toUpperCase() + _str.slice(1);
}

// used when the user logs out
// no longer used since we made FLA cookies secure and cannot access from client side. Saving function for reference.
function RemoveLoginCookies() {
  const deleteCookie = ( cookieName ) => {
    document.cookie = cookieName +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  // clear any cookies that include FLA
  // TODO: probably should update this to just start with FLA
  const a = document.cookie
    .split(';')
    .map( x => x.split('=')[0] )
    .filter( x => x.includes('FLA') )
    .forEach( cookie => deleteCookie( cookie ) );
}

// this is to remove any keys that start with "fla" assuming these will be the keys set by this app
function RemoveLocalStorageKeys() {
  // loop through keys
  Object.keys(localStorage)?.forEach( key => {
    if ( key.slice(0, 3).toLowerCase() !== 'fla' ) return;
    
    // remove key
    localStorage.removeItem(key);
  } );
}

/**
 * Takes date string from date input and returns Date object
 * @param {String} dateString date string from date input
 * @param {Boolean} start true for start of day, false for end of day
 */
function GetDate( dateString, start=false ) {
  
  const day = dateString.split('-')[2];
  const localDate = new Date( dateString );
  localDate.setDate( day );
  ( start )
    ? localDate.setHours( 0, 0, 0, 0 )
    : localDate.setHours( 23, 59, 59, 999 );

  return localDate;
};

const LocalStorageFuncs = {
  fetchUserId: () => { return localStorage.getItem( U_ID ) },
  setUserId: ( userId ) => { return localStorage.setItem( U_ID, userId ) },
  removeUserId: () => { localStorage.removeItem( U_ID) },

  fetchToken: () => { return localStorage.getItem( TOKEN_VAR ) },
  setToken: ( token ) => { return localStorage.setItem( TOKEN_VAR, token ) },
  removeToken: () => { return localStorage.removeItem( TOKEN_VAR ) },
};

function IsMobileDevice() {
  return /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}



export {
  Encrypt,
  AesEncrypt,
  AesDecrypt,
  ValidateEmail,
  SeparateWords,
  // RemoveLoginCookies,
  RemoveLocalStorageKeys,
  GetDate,
  LocalStorageFuncs,
  IsMobileDevice,
};